import { distinctUntilChanged } from 'rxjs/operators';
import { isEqual as _isEqual } from 'lodash';

export const distinctUntilDeepChanged = () => {
  return distinctUntilChanged(_isEqual);
};
